export const DATASOURCE_STATUSES_TAG = 'DATASOURCE_STATUSES_TAG';
export const DATASOURCES_TAG = 'DATASOURCES_TAG';
export const STATIONS_FULL_TAG = 'STATIONS_FULL_TAG';

export const PROGRAM_TAG = 'PROGRAM_TAG';

export const VOC_STATUSES_TAG_V2 = 'VOC_STATUSES_TAG_V2';

export const VOC_METEO_ZONES = 'VOC_METEO_ZONES';

export const DATASOURCE_PROGRAM_REPORT_COUNT_TAG = 'DATASOURCE_PROGRAM_REPORT_COUNT_TAG';

export const TELEGRAM_TYPES = 'TELEGRAM_TYPES';
export const TELEGRAM_TYPE = 'TELEGRAM_TYPE';
export const TELEGRAMS = 'TELEGRAMS';

export const H_MODELS = 'H_MODELS';
export const H_MODELS_CAN_DELETE_AND_LOGS = 'H_MODELS_CAN_DELETE_AND_LOGS';
